import type { PanelFilters } from '@content-search/domain';
import { MultiSelect } from '@soteria/design-system-ve';
import { useCallback } from 'react';

import * as styles from './FilterPanel.css';

interface ContentTypeFilterProps {
  panelFilters: PanelFilters;
  updateFilters: (updates: Partial<PanelFilters>) => void;
  isLoading: boolean;
}

const CONTENT_TYPE_OPTIONS = [
  { value: 'audio', label: 'Audio' },
  { value: 'image', label: 'Image' },
  { value: 'text', label: 'Text' },
];

// Transform content types for MultiSelect component
const getContentTypeMultiSelectOptions = () =>
  CONTENT_TYPE_OPTIONS.map(option => ({
    id: option.value,
    label: option.label,
    value: option.value,
  }));

export function ContentTypeFilter({ panelFilters, updateFilters, isLoading }: ContentTypeFilterProps) {
  const handleContentTypeChange = useCallback(
    (selectedTypes: string[]) => {
      const updates: Partial<PanelFilters> = { contentTypes: selectedTypes };

      // If audio is not included in the selected content types, clear the language filter
      if (selectedTypes.length > 0 && !selectedTypes.includes('audio')) {
        updates.languageDetected = undefined;
      }

      updateFilters(updates);
    },
    [updateFilters]
  );

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterLabel}>Content Type</div>
      <MultiSelect
        aria-label="Filter by content type"
        disabled={isLoading}
        options={getContentTypeMultiSelectOptions()}
        placeholder="All"
        selectedValues={panelFilters.contentTypes || []}
        onSelectionChange={handleContentTypeChange}
      />
    </div>
  );
}
